// @flow
import React, { Component } from 'react';
import { FormattedMessage, FormattedDate, type IntlShape } from 'react-intl';

import localizedStrings from 'util/localizedStrings';

type Props = {
  extensisAccount: ?string,
  clickSetExtensisAccount: Function,
  intl: IntlShape,
  licenseMaintenanceEndDate: ?string,
};

export default class AccountRenderer extends Component<Props> {
  clickSetAccount: Function;
  setAccountButtonRef: any;
  constructor() {
    super();
    this.clickSetAccount = this.clickSetAccount.bind(this);
  }
  clickSetAccount() {
    this.setAccountButtonRef.blur();
    this.props.clickSetExtensisAccount();
  }
  render() {
    const { extensisAccount, licenseMaintenanceEndDate } = this.props;
    const isExpiredMaintenanceEndDate = !!(
      licenseMaintenanceEndDate &&
      new Date(licenseMaintenanceEndDate) < Date.now()
    );

    return (
      <div className="box">
        <div className="title is-4">
          <FormattedMessage {...localizedStrings.USER_ACCOUNT} />
        </div>

        <button
          className="button is-medium"
          data-test-name="set-account-button"
          onClick={this.clickSetAccount}
          ref={b => {
            this.setAccountButtonRef = b;
          }}
        >
          <span>{extensisAccount}</span>
          <span className="icon is-medium has-text-primary">
            <i className="fa fa-gear" />
          </span>
        </button>

        <div className="vertical-spacer-large" />

        {licenseMaintenanceEndDate ? (
          <div className="is-indented">
            <FormattedMessage {...localizedStrings.LIC_MAINTENANCE_END_DATE} />
            <span
              style={{ marginLeft: '24px' }}
              className={isExpiredMaintenanceEndDate ? 'has-text-danger' : ''}
            >
              <FormattedDate value={licenseMaintenanceEndDate} />
            </span>

            {isExpiredMaintenanceEndDate && (
              <div>
                <div className="vertical-spacer-large" />
                <FormattedMessage
                  {...localizedStrings.LIC_CONTACT_CUSTOMER_SUCCESS_1}
                />
                &nbsp;
                <a href="mailto:info@portfoliodam.com">info@portfoliodam.com</a>
                &nbsp;
                <FormattedMessage
                  {...localizedStrings.LIC_CONTACT_CUSTOMER_SUCCESS_2}
                />
              </div>
            )}
          </div>
        ) : (
          <div className="is-indented has-text-danger">
            <FormattedMessage {...localizedStrings.LIC_ERROR_GET_ACCOUNT} />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/view/Pages/LicensesPage/AccountRenderer.js